import eventbus from '../../utils/eventbus';

const CLS_POSITIVE = 'is-positive';
const CLS_NEGATIVE = 'is-negative';

const VALUE_DEFAULT = '—';

class PerformanceIndicator {
	constructor(el, { isin, underlyingKey } = {}) {
		this.el = el;
		this.id = isin || underlyingKey;

		this.performanceEl = this.el.querySelector('[data-ref="performance"]');
		this.percentageEl = this.el.querySelector('[data-ref="performance-percentage"]');

		this.onTick = this.onTick.bind(this);

		this.start();
	}

	start() {
		if (!(this.performanceEl || this.percentageEl)) {
			console.warn(`Either performance el (${this.performanceEl}) or percentage el (${this.percentageEl}) should be present`);

			return;
		}

		eventbus.on(`tick:${this.id}`, this.onTick);
	}

	destroy() {
		eventbus.off(`tick:${this.id}`, this.onTick);
	}

	onTick(tick) {
		this.update(tick);
	}

	update(tick) {
		const performance = tick.PerformanceFormatted || tick.Performance || VALUE_DEFAULT;
		const percentage = tick.PerformancePercentageFormatted || tick.PerformancePercentage || VALUE_DEFAULT;
		const isPositive = tick.Performance > 0;

		if (this.performanceEl) {
			this.performanceEl.firstChild.nodeValue = performance;
		}

		if (this.percentageEl) {
			this.percentageEl.firstChild.nodeValue = percentage;
		}

		this.el.dataset.performance = tick.PerformancePercentage;

		this.updateState(isPositive);
	}

	updateState(isPositive) {
		this.el.classList.toggle(CLS_POSITIVE, isPositive);
		this.el.classList.toggle(CLS_NEGATIVE, !isPositive);
	}
}

export default PerformanceIndicator;
